// extracted by mini-css-extract-plugin
export var container = "_dg-0";
export var icon = "_dg-1";
export var text = "_dg-2";